import { Injectable } from 'angular-ts-decorators';
import { IHeroCustomizerV2Configuration } from './models/hero-customizer-v2.configuration';

const baseUrl = '/public-api/customizer';

@Injectable('customizerApiService')
export class CustomizerApiService {
  public static $inject: ReadonlyArray<string> = ['$http'];

  constructor(private $http: ng.IHttpService) { }

  public getHeroCustomizerV2(configurationId: string): ng.IPromise<IHeroCustomizerV2Configuration> {
    const url = `${baseUrl}/hero-customizer-v2/${configurationId}`;

    return this.$http
      .get<IHeroCustomizerV2Configuration>(url)
      .then((response: ng.IHttpResponse<IHeroCustomizerV2Configuration>) => response.data);
  }
}
